module.exports = __webpack_public_path__ + "static/Sams_pin-d396710062bdc06ab9071c07935bc885.png";